import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { ThemeProvider } from "@mui/material/styles";
import { GoogleOAuthProvider } from "@react-oauth/google";  
import CssBaseline from "@mui/material/CssBaseline";
import store from "./store/reducers/store";
import theme from "./theme";
import App from "./App";

const CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID; 

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <GoogleOAuthProvider clientId={CLIENT_ID}> 
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <App />
      </ThemeProvider>
    </GoogleOAuthProvider>
  </Provider>
);
